<template>
  <div
    class="relative w-[120px] flex-shrink-0 cursor-pointer overflow-hidden rounded-xl transition-all duration-300"
    @click="$emit('select', image)"
  >
    <img :src="image.src" :alt="image.alt" class="aspect-video w-full object-cover transition-transform duration-300" />

    <div v-if="isOriginal" class="absolute inset-0 flex items-center justify-center">
      <span class="font-medium text-white">{{ t("pages.profile-shop.compare-style.originals") }}</span>
    </div>

    <div
      class="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 transition-opacity duration-300 hover:opacity-100"
      :class="{ 'opacity-100': isSelected }"
    ></div>

    <div
      class="absolute left-2 top-2 flex h-5 w-5 items-center justify-center rounded-full bg-light-blue text-white opacity-0 transition-opacity duration-300"
      :class="{ 'opacity-100': isSelected }"
    >
      <img :src="Icons.Checkmark.src" class="h-2.5 w-2.5" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, defineEmits, computed } from "vue";
import { Icons } from "@/core-ui-vue";
import { t } from "@/locales/vue";
type CompareStyleImage = {
  key: string;
  src: string;
  alt: string;
};

const props = defineProps<{
  image: CompareStyleImage;
  isSelected: boolean;
}>();

defineEmits<{
  (e: "select", image: CompareStyleImage): void;
}>();

const isOriginal = computed(() => props.image.key === "original");
</script>
